export enum DashboardVariantEnum {
    KYC = 'KYC',
    KYT = 'KYT',
    DEEPFAKE = 'DEEPFAKE',
    CCD = 'CCD',
    BLT = 'BLT',
}
